<template>
    <div id="departments">
        <div v-if="!addShow">
            <el-form ref="form" :model="form" label-width="65px" style="overflow: hidden;">
                <el-form-item :label="$t('message.table.name')" style="width: 20%;margin-top: 20px;float: left;">
                    <el-input v-model="form.name" size="small" clearable></el-input>
                </el-form-item>
                <el-button @click="searchWorkflows" type="primary" style="margin-top: 24px;margin-left: 30px;" size="small"
                    icon="el-icon-search">{{ $t('message.button.search') }}
                </el-button>
                <el-button type="success" size="small" icon="el-icon-plus"
                    @click="addForm">{{ $t('message.button.add') }}</el-button>
            </el-form>
            <div style="padding: 0 20px 20px 20px;">
                <vxe-grid v-bind="gridOptions" @cell-dblclick="dbClick" :cell-style="cellStyle">
                    <template v-slot:operate="{ row }">
                        <vxe-button icon="el-icon-delete" :title="$t('message.button.delete')" circle
                            @click="removeRowEvent(row)"></vxe-button>
                    </template>
                </vxe-grid>
            </div>
        </div>
        <div v-if="addShow" class="add_form">
            <p>{{ $t('message.title.createprojectWorkflow') }}</p>
            <el-form :model="createForm" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="small">
                <el-form-item :label="$t('message.table.name')" prop="name" :rules="nameRule">
                    <el-input v-model="createForm.name" :style="input_width"></el-input>
                </el-form-item>

                <el-form-item :label="$t('message.table.des')">
                    <el-input v-model="createForm.description" :style="input_width"></el-input>
                </el-form-item>

                <el-form-item :label="$t('message.table.status')">
                    <el-select v-model="createForm.enabled" :placeholder="$t('message.placeholder.select')" size="small"
                        style="width:100%">
                        <el-option :label="$t('message.table.disabled')" value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm">{{ $t('message.button.createNow') }}</el-button>
                    <el-button @click="resetForm">{{ $t('message.button.reset') }}</el-button>
                    <el-button @click="breadcrumbClick" type="success">{{ $t("message.button.cancel") }}</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>
  
<style scoped>
.add_form {
    padding: 15px 60px;
    background: #fff;
}
</style>
  
<script>
import axios from "axios";
export default {
    name: 'projectWorkflows',
    data() {
        return {
            nameRule: [
                { required: true, message: this.$t('message.warning.name') }
            ],
            input_width: {}, //宽度
            createForm: {
                name: "",
                classId: "",
                description: "",
                enabled: "0",
            },
            addShow: false, //添加表格
            form: {
                name: "",
            },
            gridOptions: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: 'id',
                height: "620",
                size: "small",
                classId: [],
                columns: [
                    {
                        sortable: true,
                        field: 'name',
                        title: this.$t('message.table.name')
                    },
                    {
                        sortable: true,
                        field: 'description',
                        title: this.$t('message.table.des')
                    },
                    {
                        sortable: true,
                        field: 'enabled',
                        title: this.$t('message.table.status'),
                        editRender: {
                            name: '$select',
                            options: [{
                                label: this.$t('message.table.enabled'),
                                value: 1,
                            }, {
                                label: this.$t('message.table.disabled'),
                                value: 0,
                            }]
                        },
                    },
                    {
                        title: this.$t('message.table.actions'),
                        width: 120,
                        slots: {
                            default: 'operate'
                        }
                    }],
                data: [],
                editConfig: {
                    mode: 'row',
                    showIcon: false,
                    showStatus: true,
                },
                sortConfig: {
                    trigger: 'cell'
                },
            },
        }
    },
    mounted() { },
    methods: {
        cellStyle({ row, rowIndex, column }) {
            if (row.enabled == 0) {
                return {
                    color: '#ff0b00'
                }
            };
        },
        dbClick(row) {
            this.$store.commit("setListId", row.row.id);
            this.$router.push("/projectWorkflowInfo");
        },
        breadcrumbClick() {
            this.addShow = false;
        },
        searchWorkflows() {
            var val = this.form.name;
            var vm = this;
            axios.get('/pmdm/admin/workflow/searchWorkflow?name=' + val)
                .then(function (res) {
                    vm.gridOptions.data = res.data.object.Workflows;
                    console.log();
                })
                .catch(function (error) {
                });
        },
        Info(row) {
            this.$store.commit("setListId", row.id);
            this.$router.push("/projectWorkflowInfo");
        },
        submitForm() {
            console.log(this.createForm.name);
            this.createForm.name = this.createForm.name.trim();
            if (!this.createForm.name || this.createForm.name.match(/^[ ]*$/)) {
                this.$message.error(this.$t('message.error.name'))
                return false
            }
            this.createForm.classId = 301;
            console.log(this.createForm);
            var vm = this;
            axios.post('/pmdm/admin/workflow/saveWorkflow', this.createForm)
                .then(function (res) {
                    if (res.data.code == 200) {
                        console.log(res);
                        vm.$message({
                            type: 'success',
                            message: res.data.message,
                        });
                        vm.$store.commit("setListId", res.data.object.id);
                        vm.$router.push("/projectWorkflowInfo");
                    };
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        resetForm() {
            this.createForm = {};
        },
        addForm() {
            this.addShow = true;
            axios.get('/pmdm/admin/workflow/getSingleBaseClassList')
                .then(res => {

                    this.gridOptions.classId = res.data.object.classList;
                    console.log(this.gridOptions.classId);

                })
                .catch(function (error) {
                });
        },
        getList() {
            this.input_width = this.Global.input_width_small;
            var vm = this;
            var baseId = 301;
            axios.get('/pmdm/admin/workflow/getAll?baseId=' + baseId)
                .then(function (res) {
                    vm.gridOptions.data = res.data.object.Workflows;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        removeRowEvent(row) {
            this.$confirm(this.$t('message.confirm.deleteList'), this.$t('message.tips.tip'), {
                confirmButtonText: this.$t('message.button.affirm'),
                cancelButtonText: this.$t('message.button.cancel'),
                type: 'warning'
            }).then(() => {
                var vm = this;
                axios.get('/pmdm/admin/workflow/deleteWorkflow?id=' + row.id)
                    .then(function (res) {
                        if (res.data.code == 200) {
                            console.log(res);
                            vm.$message({
                                type: 'success',
                                message: res.data.message,
                            });
                            vm.getList();
                        };
                    })
                    .catch(function (error) {
                    });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('message.tips.deleteCancel')
                });
            });
        },
        getManualNextStatusList() {
        },
    },
    created() {
        this.getList();
    }
};
</script>